import React, { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";
import { teams } from "../../constants";
import styles from "./index.module.scss";
import { Button } from "react-bootstrap";
import { useMutation } from "react-query";
import API from "../../api";
import { AuthContext } from "../../providers/AuthProvider";

const teamList = Array.from(Object.keys(teams));

const FavTeam = ({ show, onHide, selectMode, onSelect, defaultTeamId }) => {
  const [currentTeamIndex, setCurrentTeamIndex] = useState(0);
  const [currentTeam, setCurrentTeam] = useState(null);
  const [loading, setLoading] = useState(false);

  const { user, setUser } = useContext(AuthContext);

  useEffect(() => {
    if (!defaultTeamId) return;
    const newTeamIndex = teamList.indexOf(String(defaultTeamId));
    setCurrentTeamIndex(newTeamIndex);
  }, [defaultTeamId]);

  useEffect(() => {
    const newCurrentTeam = teamList[currentTeamIndex];
    setCurrentTeam(newCurrentTeam);
  }, [currentTeamIndex]);

  const onLeftClick = () => {
    setCurrentTeamIndex((prev) => {
      if (prev - 1 === -1) return teamList.length - 1;
      return prev - 1;
    });
  };

  const onRightClick = () => {
    setCurrentTeamIndex((prev) => {
      if (prev + 1 === teamList.length) return 0;
      return (prev + 1) % teamList.length;
    });
  };

  const mutation = useMutation({
    mutationFn: (currentTeam) => {
      setLoading(true);
      return API.saveFavTeam(currentTeam);
    },
    onSuccess: (response) => {
      window.favTeamSaved = true;
      setUser({
        ...user,
        me: {
          ...user.me,
          favTeamId: response.data.FavTeamId,
          allowedFavTeamUpdates: response.data.AllowedFavTeamUpdates,
        },
      });
      setLoading(false);
      onHide();
    },
    onError: () => {
      setLoading(false);
    },
  });

  return (
    <Modal show={show} size="md" backdrop="static" onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-check2-circle"></i>&nbsp;
          {selectMode ? "Оберіть лігу" : "Оберіть улюблений клуб"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!selectMode && (
          <>
            <p>
              В залежності від вашого вибору ви автоматично станете учасником
              Ліги вболівальників обраного клубу.
            </p>
            <p>
              <strong>
                Увага! Змінити улюблений клуб можна тільки один раз!
              </strong>
            </p>
          </>
        )}
        <div className={styles.container}>
          <i
            className={`bi bi-arrow-left ${styles.icon}`}
            onClick={onLeftClick}
          ></i>
          <img
            className={styles.logo}
            src={`https://media-1.api-sports.io/football/teams/${currentTeam}.png`}
            alt=""
          />
          {teams[currentTeam]?.gift && (
            <i className={`bi bi-gift ${styles.gift}`}></i>
          )}
          <i
            className={`bi bi-arrow-right ${styles.icon}`}
            onClick={onRightClick}
          ></i>
        </div>

        <div className={styles.actions}>
          <Button
            onClick={() =>
              selectMode ? onSelect(currentTeam) : mutation.mutate(currentTeam)
            }
            className={styles.btn}
            disabled={loading || defaultTeamId === Number(currentTeam)}
          >
            {selectMode ? "Переглянути" : "Зберегти"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FavTeam;
